module.exports = __webpack_public_path__ + "static/media/eis-logo-2.5e34584a.ico";